export default __webpack_public_path__ + "static/media/download (1).20847bf5.jpg";